// The Layout wraps every page in GSAP ScrollSmoother (with normalizeScroll),
// which virtualises the window scroll position and owns scrolling entirely.
// Gatsby's default scroll handling fights this: on a back/forward navigation
// (history POP) Gatsby restores the previously-saved scroll offset with
// window.scrollTo(), which lands the freshly-created ScrollSmoother slightly
// below the top (roughly the header height). Returning false hands scroll
// ownership to ScrollSmoother, so every navigation starts cleanly at the top.
export const shouldUpdateScroll = () => false
